module.exports = __webpack_public_path__ + "static/media/backWave2.0228362f.svg";